import { render, staticRenderFns } from "./ComprasCRUD.vue?vue&type=template&id=de780f18"
import script from "./ComprasCRUD.vue?vue&type=script&lang=js"
export * from "./ComprasCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports